import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./common/css/font-awesome.min.css";

import Adminprofile from "./components/Account/Adminprofile";
import Login from "./components/Account/Login";
import Logout from "./components/Account/Logout";
import Setting from "./components/Account/Setting";
import Changepassword from "./components/Account/Changepassword";
import Forgetpassword from "./components/Account/Forgetpassword";
import Resetpassword from "./components/Account/Resetpassword";
import ProtectedLayout from "./ProtectedRoute";

import Company from "./components/Company/List";
import CompanyAdd from "./components/Company/Add";
import CompanyEdit from "./components/Company/Edit";
import CompanyView from "./components/Company/View";

import Institute from "./components/Institute/List";
import InstituteAdd from "./components/Institute/Add";
import InstituteEdit from "./components/Institute/Edit";

import Parents from "./components/Parents/List";
import ParentsAdd from "./components/Parents/Add";
import ParentsEdit from "./components/Parents/Edit";

import PluginOwner from "./components/PluginOwner/List";
import PluginOwnerAdd from "./components/PluginOwner/Add";
import PluginOwnerEdit from "./components/PluginOwner/Edit";
import PluginOwnerClone from "./components/PluginOwner/PluginClone";

import UserList from "./components/User/List";
import UserEdit from "./components/User/Edit";
import UserAdd from "./components/User/Add";
import UserView from "./components/User/View";

import BusinessList from "./components/Business/List";
import BusinessEdit from "./components/Business/Edit";
import BusinessAdd from "./components/Business/Add";
import BusinessView from "./components/Business/View";

import AdvertiserList from "./components/Advertiser/List";
import AdvertiserEdit from "./components/Advertiser/Edit";
import AdvertiserAdd from "./components/Advertiser/Add";
import AdvertiserView from "./components/Advertiser/View";

import VehicleList from "./components/Vehicle/List";
import VehicleEdit from "./components/Vehicle/Edit";
import VehicleAdd from "./components/Vehicle/Add";

import DriverAdd from "./components/Driver/Add";
import DriverList from "./components/Driver/List";
import DriverEdit from "./components/Driver/Edit";
import DriverView from "./components/Driver/View";

import CouponList from "./components/Coupon/List";
import CouponEdit from "./components/Coupon/Edit";
import CouponAdd from "./components/Coupon/Add";

import BonusManagementList from "./components/BonusManagement/List";
import BonusManagementEdit from "./components/BonusManagement/Edit";
import BonusManagementAdd from "./components/BonusManagement/Add";

import PopularCityList from "./components/PopularCity/List";
import PopularCityEdit from "./components/PopularCity/Edit";
import PopularCityAdd from "./components/PopularCity/Add";

// import AppointmentList from "./components/Appointment/List";
// import AppointmentView from "./components/Appointment/View";
// import AppointmentAdd from "./components/Appointment/Add";
// import AppointmentAssigned from "./components/Appointment/AssignedList";
// import AppointmentObservation from "./components/Appointment/ObservationList";
// import AppointmentAssignedView from "./components/Appointment/AssignedView";
// import AppointmentObservationView from "./components/Appointment/ObservationView";

// import MemList from "./components/Membership/List";
// import MemEdit from "./components/Membership/Edit";
// import MemAdd from "./components/Membership/Add";
// import MemView from "./components/Membership/View";

// import MembershipCategoryList from "./components/MembershipCategory/List";
// import MembershipCategoryAdd from "./components/MembershipCategory/Add";
// import MembershipCategoryEdit from "./components/MembershipCategory/Edit";

import Fontlist from "./components/Fonts/List";
import FontAdd from "./components/Fonts/Add";
import FontEdit from "./components/Fonts/Edit";

import TemplateList from "./components/Templates/List";
import TemplateAdd from "./components/Templates/Add";
import TemplateEdit from "./components/Templates/Edit";

import AdvertisementList from "./components/Advertisement/List";
import AdvertisementEdit from "./components/Advertisement/Edit";
import AdvertisementAdd from "./components/Advertisement/Add";

import AdvertisementCategoryList from "./components/AdvertisementCategory/List";
import AdvertisementCategoryAdd from "./components/AdvertisementCategory/Add";
import AdvertisementCategoryEdit from "./components/AdvertisementCategory/Edit";

import DashboardList from "./components/Dashboard/List";
//import Gallery from "./components/Gallery/Gallery";

import AiFeedList from "./components/AiFeed/List";
import AiImport from "./components/AiFeed/Import";

import TabList from "./components/TabManagement/List";
import TabEdit from "./components/TabManagement/Edit";
import TabAdd from "./components/TabManagement/Add";

import TabmenuList from "./components/TabMenuManagement/List";
import TabmenuEdit from "./components/TabMenuManagement/Edit";
import TabmenuAdd from "./components/TabMenuManagement/Add";
import TabmenuView from "./components/TabMenuManagement/View";



import DashboardManagement from "./components/DashboardManagement/List";
import DashboardAdd from "./components/DashboardManagement/Add";
import DashboardEdit from "./components/DashboardManagement/Edit";

import CmsList from "./components/Cms/List";
import CmsAdd from "./components/Cms/Add";
import CmsEdit from "./components/Cms/Edit";
import CmsView from "./components/Cms/View";

import GuideList from "./components/Guide/List";
import GuideEdit from "./components/Guide/Edit";
import GuideAdd from "./components/Guide/Add";

import GuideCategoryList from "./components/GuideCategory/List";
import GuideCategoryAdd from "./components/GuideCategory/Add";
import GuideCategoryEdit from "./components/GuideCategory/Edit";
import GuideSubCategoryList from "./components/GuideSubCategory/List";
import GuideSubCategoryAdd from "./components/GuideSubCategory/Add";
import GuideSubCategoryEdit from "./components/GuideSubCategory/Edit";

import Shortcuticon from "./components/Shortcuticon/List";
import ShortcuticonAdd from "./components/Shortcuticon/Add";
import ShortcuticonEdit from "./components/Shortcuticon/Edit";

import EMOJIList from "./components/EmojiIcons/List";
import EMOJIEdit from "./components/EmojiIcons/Edit";
import EMOJIAdd from "./components/EmojiIcons/Add";

import JSONAdd from "./components/Jsonaifeed/Add";
import JSONList from "./components/Jsonaifeed/List";
import JSONView from "./components/Jsonaifeed/View";
import JSONEdit from "./components/Jsonaifeed/Edit";

import MemList from "./components/Membership/List";
import MemEdit from "./components/Membership/Edit";
import MemAdd from "./components/Membership/Add";
import MemView from "./components/Membership/View";

import MembershipCategoryList from "./components/MembershipCategory/List";
import MembershipCategoryAdd from "./components/MembershipCategory/Add";
import MembershipCategoryEdit from "./components/MembershipCategory/Edit";

import ThemeList from "./components/Themes/List";
import ThemeAdd from "./components/Themes/Add";
import ThemeEdit from "./components/Themes/Edit";

import ThemeColorList from "./components/ThemeColor/List";
import ThemeColorAdd from "./components/ThemeColor/Add";
import ThemeColorEdit from "./components/ThemeColor/Edit";

import Reason from "./components/Reasons/List";
import ReasonAdd from "./components/Reasons/Add";
import ReasonEdit from "./components/Reasons/Edit";

import RelationshipType from "./components/RelationshipType/List";
import RelationshipTypeAdd from "./components/RelationshipType/Add";
import RelationshipTypeEdit from "./components/RelationshipType/Edit";

import WalletPlanList from "./components/WalletPlans/List";
import WalletPlanAdd from "./components/WalletPlans/Add";
import WalletPlanEdit from "./components/WalletPlans/Edit";

import "./common/css/custom.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route path="/changepassword" element={<Changepassword />} />
      <Route path="/forget_password" component={Forgetpassword} />
      <Route path="/reset_password/:key" component={Resetpassword} />

      <Route element={<ProtectedLayout />}>
        <Route exact path="/profile" element={<Adminprofile />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/setting" element={<Setting />} />
        
        <Route path="/company" element={<Company />} />
        <Route path="/company-add" element={<CompanyAdd />} />
        <Route path="/company-edit/:ID" element={<CompanyEdit />} />
        <Route path="/company-view/:ID" element={<CompanyView />} />

        <Route path="/institute" element={<Institute />} />
        <Route path="/institute-add" element={<InstituteAdd />} />
        <Route path="/institute-edit/:ID" element={<InstituteEdit />} />

        <Route path="/parents" element={<Parents />} />
        <Route path="/parents-add" element={<ParentsAdd />} />
        <Route path="/parents-edit/:ID" element={<ParentsEdit />} />

        <Route path="/pluginowner" element={<PluginOwner />} />
        <Route path="/pluginowner-add" element={<PluginOwnerAdd />} />
        <Route path="/pluginowner-edit/:ID" element={<PluginOwnerEdit />} />
        <Route path="/pluginowner-clone/:ID" element={<PluginOwnerClone />} />

        <Route path="/font-edit/:ID" element={<FontEdit />} />
        <Route path="/fonts" element={<Fontlist />} />
        <Route path="/font-add" element={<FontAdd />} />

        <Route path="/user" element={<UserList />} />
        <Route path="/user-add" element={<UserAdd />} />
        <Route path="/user-edit/:ID" element={<UserEdit />} />
        <Route path="/user-view/:ID" element={<UserView />} />

        <Route path="/business" element={<BusinessList />} />
        <Route path="/business-add" element={<BusinessAdd />} />
        <Route path="/business-edit/:ID" element={<BusinessEdit />} />
        <Route path="/business-view/:ID" element={<BusinessView />} />

        <Route path="/advertiser" element={<AdvertiserList />} />
        <Route path="/advertiser-add" element={<AdvertiserAdd />} />
        <Route path="/advertiser-edit/:ID" element={<AdvertiserEdit />} />
        <Route path="/advertiser-view/:ID" element={<AdvertiserView />} />


        <Route path="/vehicle" element={<VehicleList />} />
        <Route path="/vehicle-add" element={<VehicleAdd />} />
        <Route path="/vehicle-edit/:ID" element={<VehicleEdit />} />

        <Route path="/drivers" element={<DriverList />} />
        <Route path="/drivers-add" element={<DriverAdd />} />
        <Route path="/drivers-edit/:ID" element={<DriverEdit />} />
        <Route path="/drivers-view/:ID" element={<DriverView />} />

        <Route path="/coupon" element={<CouponList />} />
        <Route path="/coupon-add" element={<CouponAdd />} />
        <Route path="/coupon-edit/:ID" element={<CouponEdit />} />

        <Route path="/bonusManagement" element={<BonusManagementList />} />
        <Route path="/bonus-add" element={<BonusManagementAdd />} />
        <Route path="/bonus-edit/:ID" element={<BonusManagementEdit />} />

        <Route path="/popularcity" element={<PopularCityList />} />
        <Route path="/popularcity-add" element={<PopularCityAdd />} />
        <Route path="/popularcity-edit/:ID" element={<PopularCityEdit />} />
        
        <Route path="/theme" element={<ThemeList />} />
        <Route path="/theme-add" element={<ThemeAdd />} />
        <Route path="/theme-edit/:ID" element={<ThemeEdit />} />

        <Route path="/themecolor" element={<ThemeColorList />} />
        <Route path="/themecolor-add" element={<ThemeColorAdd />} /> 
        <Route path="/themecolor-edit/:ID" element={<ThemeColorEdit />} /> 

        {/*<Route path="/appointments" element={<AppointmentList/>} />
      <Route path="/appointment-view/:ID" element={<AppointmentView/>} />
      <Route path="/appointment-add" element={<AppointmentAdd/>} />
      <Route path="/appointment-assigned" element={<AppointmentAssigned/>} />
      <Route path="/appointment-observation" element={<AppointmentObservation/>} />
      <Route path="/appointment-assignedview/:ID" element={<AppointmentAssignedView/>} />
      <Route path="/appointment-observationview/:ID" element={<AppointmentObservationView/>} />

      
      <Route path="/membership" element={<MemList/>}  />
        <Route path="/membership-edit/:ID" element={<MemEdit/>} />
        <Route path="/membership-view/:ID" element={<MemView/>} />
        <Route path="/membership-add" element={<MemAdd/>} />

        <Route path="/membershipcategory" element={<MembershipCategoryList/>}  />
        <Route path="/membershipcategory-add" element={<MembershipCategoryAdd/>} />
        <Route path="/membershipcategory-edit/:ID" element={<MembershipCategoryEdit/>} />
       <Route path="/user" element={UserList} />
      <Route path="/edit/:ID" element={UserEdit} />
      <Route path="/view/:ID" element={UserView} />
      <Route path="/user-add" element={UserAdd} />
      <Route path="/user-import" element={UserImport} /> */}

        <Route path="/templates" element={<TemplateList />} />
        <Route path="/template/add" element={<TemplateAdd />} />
        <Route path="/templates-edit/:ID" element={<TemplateEdit />} />
        <Route path="/dashboard" element={<DashboardList />} />
        
        {/*   <Route path="/faqcategory" element={<FaqCategoryList/>} />
      <Route path="/faqcategory-add" element={<FaqCategoryAdd/>} />
      <Route path="/faqcategory-edit/:ID" element={<FaqCategoryEdit/>} />  

      <Route path="/faq" element={<FaqList/>} />
      <Route path="/faq-add" element={<FaqAdd/>} />
      <Route path="/faq-edit/:ID" element={<FaqEdit/>} />
      <Route path="/faq-import" element={<FaqImport/>} />

      <Route path="/amenities" element={<AmenityList/>} />
      <Route path="/amenity-add" element={<AmenityAdd/>} />
      <Route path="/amenity-edit/:ID" element={<AmenityEdit/>} />*/}

        <Route path="/aifeed" element={<AiFeedList />} />
        <Route path="/aifeed-import" element={<AiImport />} />

        <Route path="/tabmanagement" element={<TabList />} />
        <Route path="/tabmanagement-edit/:ID" element={<TabEdit />} />
        <Route path="/tabmanagement-add" element={<TabAdd />} />

        <Route path="/tabmenumanagement" element={<TabmenuList />} />
        <Route path="/tabmenumanagement-edit/:ID" element={<TabmenuEdit />} />
        <Route path="/tabmenumanagement-add" element={<TabmenuAdd />} />
        <Route path="/tabmenumanagement-view/:ID" element={<TabmenuView />} />

        <Route path="/dashboardmanagement" element={<DashboardManagement />} />
        <Route
          path="/dashboardmanagement-edit/:ID"
          element={<DashboardEdit />}
        />
        {/* <Route path="/dashboardmanagement-add" component={<DashboardAdd/>} /> */}

        <Route path="/advertisement" element={<AdvertisementList />} />
        <Route path="/advertisement-add" element={<AdvertisementAdd />} />
        <Route path="/advertisement-edit/:ID" element={<AdvertisementEdit />} />

        <Route
          path="/advertisementcategory"
          element={<AdvertisementCategoryList />}
        />
        <Route
          path="/advertisementcategory-add"
          element={<AdvertisementCategoryAdd />}
        />
        <Route
          path="/advertisementcategory-edit/:ID"
          element={<AdvertisementCategoryEdit />}
        />

        <Route path="/Cms" element={<CmsList />} />
        <Route path="/Cms-add" element={<CmsAdd />} />
        <Route path="/Cms-edit/:ID" element={<CmsEdit />} />
        <Route path="/Cms-view/:ID" element={<CmsView />} />

        <Route path="/guide" element={<GuideList />} />
        <Route path="/guide-edit/:ID" element={<GuideEdit />} />
        <Route path="/guide-add" element={<GuideAdd />} />

        <Route path="/guidecategory" element={<GuideCategoryList />} />
        <Route path="/guidecategory-add" element={<GuideCategoryAdd />} />
        <Route path="/guidecategory-edit/:ID" element={<GuideCategoryEdit />} />

        <Route path="/guidesubcategory" element={<GuideSubCategoryList />} />
        <Route path="/guidesubcategory-add" element={<GuideSubCategoryAdd />} />
        <Route
          path="/guidesubcategory-edit/:ID"
          element={<GuideSubCategoryEdit />}
        />

        <Route path="/shortcuticon/edit/:ID" element={<ShortcuticonEdit />} />
        <Route path="/shortcuticon" element={<Shortcuticon />} />
        <Route path="/shortcuticon-add" element={<ShortcuticonAdd />} />

        <Route path="/emoji" element={<EMOJIList />} />
        <Route path="/emoji-edit/:ID" element={<EMOJIEdit />} />
        <Route path="/emoji-add" element={<EMOJIAdd />} />

        <Route path="/json" element={<JSONList />} />
        <Route path="/json-add" element={<JSONAdd />} />
        <Route path="/json-view/:ID" element={<JSONView />} />
        <Route path="/json-edit/:ID" element={<JSONEdit />} />

        <Route path="/membership" element={<MemList />} />
        <Route path="/membership-edit/:ID" element={<MemEdit />} />
        <Route path="/membership-view/:ID" element={<MemView />} />
        <Route path="/membership-add" element={<MemAdd />} />

        <Route
          path="/membershipcategory"
          element={<MembershipCategoryList />}
        />
        <Route
          path="/membershipcategory-add"
          element={<MembershipCategoryAdd />}
        />
        <Route
          path="/membershipcategory-edit/:ID"
          element={<MembershipCategoryEdit />}
        />
         <Route
          path="/walletplans"
          element={<WalletPlanList />}
        />
        <Route
          path="/walletplan-add"
          element={<WalletPlanAdd />}
        />
        <Route
          path="/walletplan-edit/:ID"
          element={<WalletPlanEdit />}
        />
         //<Route path="/walletplan-view/:ID" element={<MemView />} />
        
        <Route path="/reason" element={<Reason/>} />
        <Route path="/reason-edit/:ID" element={<ReasonEdit/>} />
        <Route path="/reason-add" element={<ReasonAdd />} />

        <Route path="/relationshiptype" element={<RelationshipType/>} />
        <Route path="/relationshiptype-edit/:ID" element={<RelationshipTypeEdit/>} />
        <Route path="/relationshiptype-add" element={<RelationshipTypeAdd />} />
        
      </Route>
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
